import { useState } from 'react'
import {
  Box,
  Typography,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  CircularProgress,
} from '@mui/material'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import { LoadingButton } from '@mui/lab'
import { useProject } from '../../context/ProjectContext'
import ProjectService from '../../services/ProjectService'
import { useNotification } from '../../context/NotificationContext'

const LoginFailedModal = ({
  loginFailedOpen,
  setLoginFailedOpen
}) => {
  const { selectedProject } = useProject()
  const showNotification = useNotification()
  const [reTryLoginLoading, setReTryLoginLoading] = useState(false)

  const handleClose = () => {
    setLoginFailedOpen(false)
  }

  const handleReTry = async () => {
    if (!selectedProject?.id) {
      showNotification('No project selected', 'error', '')
      return
    }

      setReTryLoginLoading(true)
    try {
      await ProjectService.retryLogin(selectedProject.id)
      showNotification('Login retry initiated', 'success', '')
      setLoginFailedOpen(false)
    } catch (error) {
      console.error('Error retrying login:', error)
      showNotification(
        error.response?.data?.message || 'Failed to retry login',
        'error',
        ''
      )
    } finally {
      setReTryLoginLoading(false)
    }
  }

  return (
    <Dialog open={loginFailedOpen} onClose={handleClose}>
      <Box className="loginFailedModal">
        <DialogTitle className="loginFailedModalTitle">
          <InfoOutlinedIcon className="loginFailedModalTitleIcon" color='secondary'/>
          Login Failed
        </DialogTitle>
        <DialogContent className="loginFailedModalContent">
          <Typography variant='body1'>
            We cannot reach the page with our automated browser. If you own this website, please disable the protection and try again.
          </Typography>
        </DialogContent>
        <DialogActions className="loginFailedModalActions">
          <Button className="loginFailedModalButton" onClick={handleClose} color="secondary" variant="outlined">
            CANCEL
          </Button>
          {reTryLoginLoading ? (
            <LoadingButton
              loading
              className="loginFailedModalButton"
              variant="contained"
              loadingIndicator={<CircularProgress color="white" size={16} />}
            />
          ) : (
            <Button className="loginFailedModalButton" onClick={handleReTry} color="secondary" variant="contained">
              RE-TRY
            </Button>
          )}
        </DialogActions>
      </Box>
    </Dialog>
  )
}

export default LoginFailedModal